import { Box, TextField } from '@mui/material'
import { ChangeEvent } from 'react'
import { Services } from '../../../../../store/slices/timesheet/timesheetPageSlice'
import { LightTooltip } from '../../../../LighTooltip'

const altTextFieldStyle = {
	fontFamily: 'Poppins, sans-serif',
	border: 'none',
	outline: 'none',
	minWidth: 0,
	'& .MuiInputBase-root': {
		backgroundColor: 'transparent',
		padding: '2px',
		border: 'none',
	},
	'& fieldset': {
		border: 'none',
	},
}

interface ServicePassengersProps {
	isReserveService: boolean
	isSecondaryDriverService: boolean
	passengers: number
	onPassengersChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
	showPassengersTooltip: boolean
	passengersTooltipOpen: boolean
	setPassengersTooltipOpen: (open: boolean) => void
	serviceDetail: Services
}

export default function ServicePassengers({
	isReserveService,
	isSecondaryDriverService,
	passengers,
	onPassengersChange,
	showPassengersTooltip,
	passengersTooltipOpen,
	setPassengersTooltipOpen,
	serviceDetail,
}: Readonly<ServicePassengersProps>) {
	return (
		<Box sx={{ width: '80px', margin: 'auto 0', padding: '0.75rem 1rem', display: 'flex', alignItems: 'center' }}>
			{isReserveService ? (
				'-'
			) : (
				<LightTooltip
					title={
						(serviceDetail.serviceExecution?.pax ?? 0) < (serviceDetail.service?.pax ?? 0)
							? 'Inferior ao Valor Escalado'
							: 'Excede o Valor Escalado'
					}
					open={passengersTooltipOpen && showPassengersTooltip}
					onOpen={() => setPassengersTooltipOpen(true)}
					onClose={() => setPassengersTooltipOpen(false)}
					placement='top'
				>
					<TextField
						aria-label='Number of Passengers'
						size='small'
						type='number'
						disabled={isSecondaryDriverService}
						value={passengers}
						onClick={e => e.stopPropagation()}
						onChange={onPassengersChange}
						inputProps={{ style: { fontSize: '0.75rem', padding: '2px', backgroundColor: 'rgba(245, 247, 252, 0.5)' } }}
						InputProps={{
							disableUnderline: true,
							sx: {
								position: 'relative',
								width: '3rem',
								fontSize: '0.75rem',
								padding: '2px',
								border: 'none',
								color: showPassengersTooltip ? 'var(--warning)' : 'var(--primary-dark)',
								'& .MuiInputBase-input': {
									color: showPassengersTooltip ? 'var(--warning)' : 'var(--primary-dark)',
									padding: '2px',
									fontSize: '0.75rem',
									backgroundColor: 'rgba(245, 247, 252, 0.5)',
								},
							},
						}}
						sx={altTextFieldStyle}
					/>
				</LightTooltip>
			)}
		</Box>
	)
}
